var RLJPickupReadiness = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // work/pickup-today/readiness.js
  var readiness_exports = {};
  __export(readiness_exports, {
    pickupMessage: () => pickupMessage,
    refresh: () => refresh
  });

  // work/survey-timing/app/extensions/rlj-survey/src/timing.js
  var STORE_TIME_ZONE = "America/New_York";
  var DAY = 864e5;
  var format = new Intl.DateTimeFormat("en-CA", {
    timeZone: STORE_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  });
  function localParts(instant) {
    const date = new Date(instant);
    if (!Number.isFinite(date.getTime())) throw new Error("A valid order time is required.");
    const p = Object.fromEntries(format.formatToParts(date).map((x) => [x.type, x.value]));
    return { date: `${p.year}-${p.month}-${p.day}`, minute: Number(p.hour) * 60 + Number(p.minute) };
  }
  function addDays(date, days) {
    return new Date(Date.parse(date + "T12:00:00Z") + days * DAY).toISOString().slice(0, 10);
  }
  function weekday(date) {
    return (/* @__PURE__ */ new Date(date + "T12:00:00Z")).getUTCDay();
  }
  function isOpen(date, days, closed) {
    return days.includes(weekday(date)) && !closed.has(date);
  }
  function nextOpen(date, days, closed) {
    for (let n = 0; n < 400; n++, date = addDays(date, 1)) if (isOpen(date, days, closed)) return date;
    throw new Error("No available business day in the calendar.");
  }
  function nthWeekday(year, month, day, nth) {
    let d = `${year}-${String(month).padStart(2, "0")}-01`;
    return addDays(d, (day - weekday(d) + 7) % 7 + (nth - 1) * 7);
  }
  function lastWeekday(year, month, day) {
    const firstNext = month === 12 ? `${year + 1}-01-01` : `${year}-${String(month + 1).padStart(2, "0")}-01`;
    const last = addDays(firstNext, -1);
    return addDays(last, -((weekday(last) - day + 7) % 7));
  }
  function majorClosures(year) {
    return [
      `${year}-01-01`,
      lastWeekday(year, 5, 1),
      `${year}-07-04`,
      nthWeekday(year, 9, 1, 1),
      nthWeekday(year, 11, 4, 4),
      `${year}-12-25`
    ];
  }
  function estimateDelivery({ placedAt, kind, countryCode, closedDates = [], useMajorClosures = true }) {
    const { date, minute } = localParts(placedAt);
    const country = typeof countryCode === "string" ? countryCode.toUpperCase() : "";
    if (kind !== "pickup" && kind !== "shipping") throw new Error("The selected delivery method is required.");
    if (kind === "shipping" && !/^[A-Z]{2}$/.test(country)) throw new Error("The delivery country is required.");
    if (kind === "shipping" && country !== "US") {
      return { countryCode: country, estimatedDeliveryDate: addDays(date, 25), rule: "international_25_calendar_days" };
    }
    const closed = new Set(closedDates);
    if (useMajorClosures) for (let year = Number(date.slice(0, 4)); year <= Number(date.slice(0, 4)) + 2; year++) {
      for (const day of majorClosures(year)) closed.add(day);
    }
    if (kind === "pickup") {
      const days = [1, 2, 3, 4, 5, 6];
      const readyMinute = Math.max(minute, 10 * 60) + 60;
      const readyDate = isOpen(date, days, closed) && readyMinute < 17 * 60 ? date : nextOpen(addDays(date, 1), days, closed);
      return { countryCode: "US", estimatedDeliveryDate: readyDate, rule: "pickup_1_hour_during_store_hours" };
    }
    let dispatchDate = nextOpen(minute < 14 * 60 ? date : addDays(date, 1), [1, 2, 3, 4], closed);
    const arrivalDate = nextOpen(addDays(dispatchDate, 1), [1, 2, 3, 4, 5], closed);
    return { countryCode: "US", estimatedDeliveryDate: arrivalDate, dispatchDate, rule: "domestic_overnight_business_calendar" };
  }

  // work/pickup-today/readiness.js
  function pickupMessage(now) {
    const today = localParts(now);
    const result = estimateDelivery({ placedAt: now, kind: "pickup", countryCode: "US" });
    if (result.estimatedDeliveryDate === today.date) {
      return today.minute < 600 ? "Free pickup today \u2014 usually ready by 11 AM" : "Free pickup today \u2014 usually ready in 1 hour";
    }
    const day = result.estimatedDeliveryDate === addDays(today.date, 1) ? "tomorrow" : new Intl.DateTimeFormat("en-US", { timeZone: "UTC", weekday: "long", month: "long", day: "numeric" }).format(/* @__PURE__ */ new Date(result.estimatedDeliveryDate + "T12:00:00Z"));
    return `Free pickup ${day} \u2014 usually ready by 11 AM`;
  }
  function refresh(root = document, now = /* @__PURE__ */ new Date()) {
    root.querySelectorAll("[data-rlj-pickup-ready]").forEach((element) => {
      element.textContent = pickupMessage(now);
    });
  }
  return __toCommonJS(readiness_exports);
})();

if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        RLJPickupReadiness.refresh(this);
        if (this.hasAttribute('available')) this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        this.requestedVariantId = String(variantId);
        const preview = this.querySelector('pickup-availability-preview');
        if (preview && String(this.dataset.variantId) !== String(variantId)) preview.hidden = true;
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => {if (!response.ok) throw new Error('Pickup availability unavailable'); return response.text();})
          .then((text) => {
            if (this.requestedVariantId !== String(variantId)) return;
            this.dataset.variantId = String(variantId);
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            if (this.requestedVariantId !== String(variantId)) return;
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.id) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        RLJPickupReadiness.refresh(this);

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}

if (!window.rljPickupReadinessTimer) {
  window.rljPickupReadinessTimer = window.setInterval(() => RLJPickupReadiness.refresh(document), 60000);
}
